import { Link, useNavigate } from "react-router-dom";

import { faCheckCircle, faEarthEurope, faPlusCircle, faXmarkCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { InfoColumn, InfoColumnValue, InfoRow } from "components/atoms/InfoRow";
import Error from "components/molecules/Error";
import Loading from "components/molecules/Loading";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { useGetFeatureFlagsQuery } from "pages/Features/Feature flags/FeatureFlags.graphql-gen";

export default function FeatureFlagsPage() {
	const navigate = useNavigate();
	const { data, error, loading } = useGetFeatureFlagsQuery();

	return (
		<div>
			<MainLayoutPageHeader
				title={
					<Flex gap="var(--grid-2)">
						Feature flags
						<Link to="0" title="Ny feature">
							<FontAwesomeIcon icon={faPlusCircle} />
						</Link>
					</Flex>
				}
				intro={"Funksjonalitet man kan slå av og på. Features er enten globale, eller for grupper."}
			/>
			<Flex style={{ marginTop: "40px", borderRadius: "15px", overflow: "hidden" }} direction={Direction.column}>
				{error && !loading && <Error errorMessage="Feil ved henting av feature flags" />}
				{loading && !data && <Loading />}
				{data?.featureFlags?.map((featureFlag) => (
					<InfoRow
						key={featureFlag.id}
						interactive
						onClick={() => {
							navigate("/features/" + featureFlag.id);
						}}
					>
						<InfoColumn width="25%">
							<InfoColumnValue>
								<b>{featureFlag?.displayName}</b>
							</InfoColumnValue>
						</InfoColumn>
						<InfoColumn width="10%">
							<InfoColumnValue>
								{featureFlag?.enabled && <FontAwesomeIcon title="Aktivert" icon={faCheckCircle} color="green" />}
								{!featureFlag?.enabled && <FontAwesomeIcon title="Deaktivert" icon={faXmarkCircle} color="red" />}
							</InfoColumnValue>
						</InfoColumn>
						<InfoColumn width="10%">
							<InfoColumnValue>
								{featureFlag.global && <FontAwesomeIcon title="Global" icon={faEarthEurope} />}
								{!featureFlag.global && featureFlag.enabled && featureFlag.usersCount + " brukere"}
							</InfoColumnValue>
						</InfoColumn>
					</InfoRow>
				))}
			</Flex>
		</div>
	);
}
